import React, {CSSProperties, FunctionComponent} from "react";
import {Box, Button, makeStyles} from "@material-ui/core";
import checkedIcon from "../images/Button/checked-small.svg";
import checkedSelectIcon from "../images/Button/checked-select.svg";
import uncheckedIcon from "../images/Button/unchecked-small.svg";
import Text from "./Text";

const useStyles = makeStyles(() => ({
    btn: {
        padding: 0,
        paddingRight: 6,
        textTransform: "none",
        minWidth: 0
    },
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    },
    textContainer: {
        paddingLeft: 6
    }
}));

interface CheckBoxProps {
    text?: any;
    checked?: boolean;
    onClick?: () => void;
    style?: CSSProperties;
    className?: string;
    select?: boolean;
    disabled?: boolean
}

const CheckBox: FunctionComponent<CheckBoxProps> = ({text, checked, style, onClick, className, select, disabled}) => {

    const classes = useStyles();

    return (
        <Box className={className}>
            <Button classes={{root: classes.btn}} style={style} onClick={onClick} disabled={disabled}>
                <Box className={classes.container}>
                    {checked
                        ? <img src={select ? checkedSelectIcon : checkedIcon} alt={""}/>
                        : <img src={uncheckedIcon} alt={""}/>}
                    {text && <Box className={classes.textContainer}><Text value={text} size={12}/></Box>}
                </Box>
            </Button>
        </Box>
    );
};

export default CheckBox;

